import { createContext, useContext } from "react";
export const LayoutContext = createContext({ isFullWidth: false, setIsFullWidth: () => {} });
export const useLayout = () => useContext(LayoutContext);
